import React from "react"
import styled from "styled-components"
import { breakpoints, spacers } from "../../styles/variables"
import RoundedImage from "../RoundedImage"
import Text from "./Text"
import Button from "../Button"


const TextDiv = styled.article`
    width: 100%;
    p {
        margin-bottom: ${spacers.s}px;
    }

    .articleWrapper {
        display: flex;
    }

    .imageButton {
        margin-top: 20px;
        width: 216px;
    }

    @media screen AND (min-width: ${breakpoints.m}px) {
        p {
            margin-bottom: 26px;
        }
        img {
            float: left;
        }

        .mobileDisplayNone {
            > div > img {
                margin: 0 25px 10px 0;
            }
        }

        .imageButton {
            margin-right: 0;
            margin-left: auto;
            width: 234px;
        }
    }

    @media screen AND (min-width: ${breakpoints.l}px) {
        .imageButton {
            width: 293px;
        }
    }
`


const TextWithImage = ({kurs}) => <TextDiv>
    <Text>
        <div class="articleWrapper">
            <div className="mobileDisplayNone">
                <RoundedImage image={kurs.image} contentImage />

                <div className="imageButton">
                    <Button link="/kontakt" text="Jetzt anmelden" />
                </div>
            </div>
            <div>
                <p>
                    <strong dangerouslySetInnerHTML={{__html: kurs.lead}} />
                </p>
                <div className="tdDisplayNone">
                    <RoundedImage image={kurs.image} contentImage />
                    {/* grösse korrigieren */}
                </div>

                <div className="beschreibung" dangerouslySetInnerHTML={{__html: kurs.beschreibung}} />
            </div>
        </div>
       
    </Text>
</TextDiv>

export default TextWithImage